<span [class]="classes()">
  @if (icon() && iconOnly()) {
    <span class="ntt-badge__icon" [class]="icon()"></span>
  } @else {
    @if (closable()) {
      <button
        type="button"
        aria-label="Close"
        [class]="closeClasses()"
        (click)="_onClose($event)"
      >
        <span class="icon-x-close"></span>
      </button>
    }
    @if (icon() && iconPosition() === "start" && !hasStartSlot()) {
      <span class="ntt-badge__icon" [class]="icon()"></span>
    }

    <ng-content select="[nttBadgeStart],[badge-icon-start]" />

    @if (dot()) {
      <span
        class="ntt-badge__dot"
        [class.ntt-badge__dot--outline]="dotOutline()"
      ></span>
    }
    @if (avatarText()) {
      <span class="ntt-badge__avatar">
        <ng-content select="[nttBadgeAvatar]" />
      </span>
    }
    @if (hasContentSlot()) {
      <ng-content select="[nttBadgeContent]" />
    } @else {
      <ng-content />
    }
    @if (icon() && iconPosition() === "end" && !hasEndSlot()) {
      <span class="ntt-badge__icon" [class]="icon()"></span>
    }

    <ng-content select="[nttBadgeEnd],[badge-icon-end]" />
  }
</span>
